import * as actions_authentication from 'actions/authentication-actions';
import * as toolbox from 'components/common/toolbox';
import React from 'react';
import { Avatar } from 'enspire-manager-framework';
import { ROLES } from 'components/common/constants';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Dropdown } from 'react-bootstrap';

const _ = require('lodash');

export default function UserProfile(props) {

    const params = useParams();
    const dispatch = useDispatch();

    var user = props.user;
    var email = props.email; //.split('@');
    var name = user?.firstName + ' ' + user?.lastName;

    var roles = [];
    if (user?.roles) {
        user.roles.forEach((roleId) => {
            let role = _.findKey(ROLES, (role) => { return role.id == roleId; });
            roles.push(toolbox.toProperCase(role));
        });
    }

    const logOut = (event) => {
        event.preventDefault();
        dispatch(actions_authentication.logout());
    }

    const badges = roles.map((role) => <span key={role} className="text-capitalize mt-1 ml-1 badge">{role}</span>);

    return (
        <div className="mt-4 text-center mb-3 px-3" style={{ width: '100%', color: '#a7b1c2' }}>
            {user &&
                props.collapsed ?
                <div className="avatar-container">
                    <Avatar className="mx-auto mb-3 my-auto" size={50} fontSize={20} name={name} image={user.photoUrl} border='2px solid white' />
                </div>
                : <div className="animated fadeIn" style={{ width: '207px' }}>
                    <h2 className="mt-4 mb-3 text-center text-white font-bold">{ props.companyName }</h2>

                    <Dropdown>
                        <Dropdown.Toggle as="div" className="dropdown-toggle no-caret row justify-content-between">
                            <Avatar className="ml-auto" size={70} fontSize={30} name={name} image={user.photoUrl} border='2px solid white' />
                            <i style={{ cursor: 'pointer' }} className="fas fa-user-cog fa-lg mr-auto mt-auto mb-1 ml-2" aria-hidden="true"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="ml-4 mt-2" style={{ overflow: 'hidden' }}>
                            <Dropdown.Item onClick={ (event) => logOut(event) }>Log Out</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item href={'/#/' + params.handle + '/account_delete'} className='text-danger'>Delete Account</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    <h3 className='mb-1 mt-3 text-white'>{name}</h3>
                    <p className="mb-2">{email}</p>
                    {badges}
                </div>
            }
        </div>
    );
}
